export enum WEBINAR_URL {
  WEBINAR_URL_GUIDE = "https://gomeet.vnpt.vn/docs/docs/widget/token"
}
